































































import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { LocaleMessages } from 'vue-i18n';

@Component
export default class TextAreaField extends Vue {
  @Model('change', { type: String }) value!: string;
  @Prop({ type: [String, Object], required: true }) label!:
    | string
    | LocaleMessages;
  @Prop({ type: Boolean, default: false }) disabled!: string;
  @Prop({ type: Boolean, default: false }) readonly!: string;
  @Prop({ type: [Number, String], default: 3 }) rows!: number | string;
  @Prop({ type: [Number, String] }) maxLength?: number | string;

  private get length(): number {
    return this.value?.length || 0;
  }
}
